import axios from '../../../http';
import formatModel from './format-model';

function initialState() {
  return {
    exchanged: null,
    completionDate: null,
    postcode: '',
    address: {},
    compareFuel: null,
    sameSupplier: null,
    electricitySmartMeter: false,
    gasSmartMeter: false,
    isEconomy7: false,
    isElectricityMorethanGas: false,
    tariff: {},
    tariffValidToDate: null,
    supplierId: null,
    currentPayMethod: '',
    utilityPeriod: '',
    currentCostEstimated: null,
    currentUsageEstimated: null,
    usage: null,
    gasUsage: { usage: null, cost: null, usageType: 1, usageUnit: 1 },
    electricityUsage: { usage: null, cost: null, usageType: 1, usageUnit: 1 },
    electricityTariffValidToDate: null,
    electricityConsumptionExceedsGasConsumption: false,
    electricitySupplierId: null,
    electricityTariff: {},
    electricityCurrentPayMethod: null,
    economy7Percentage: 42,
    gasTariffValidToDate: null,
    gasSupplierId: null,
    gasTariff: {},
    gasCurrentPayMethod: null,
    newTariffPaymentMethod: 'monthlyDirectDebit',
    gdprConsent: null
  };
}

const state = initialState();

const getters = {
  quote: state => state,
  quoteType: state => {
    let value;

    switch (state.compareFuel) {
      case 'gas':
        value = 'gasToGas';
        break;

      case 'electricity':
        value = 'electricityToElectricity';
        break;

      case 'gasElectricity':
        value = state.sameSupplier === 'no' ? 'dualDistinctToDualConsolidated' : 'dualConsolidatedToDualConsolidated';
        break;

      default:
        value = 'gasToGas';
    }

    return value;
  },
  is02Meter: state => {
    const address = state.address.parts;

    if (state.compareFuel == 'gas') return false;
    if (address) {
      const meter = address.elecdetails.find(({ isDomestic }) => isDomestic);

      if (meter) {
        return meter.mpan.substring(0, 2) === '02';
      }

      return state.isEconomy7;
    }

    return state.isEconomy7;
  },
  noMpan: state => {
    const address = state.address.parts;

    if (state.compareFuel == 'gas') return false;
    if (address) {
      const elecdetails = address.elecdetails.find(({ isDomestic }) => isDomestic);

      return elecdetails ? !elecdetails.mpan : true;
    }

    return false;
  },
  notPrePaymentMeter: state => !(state.currentPayMethod === 'prePaymentMeter' || state.electricityCurrentPayMethod === 'prePaymentMeter' || state.gasCurrentPayMethod === 'prePaymentMeter')
};

const actions = {
  initialiseState({ commit }) {
    const storage = localStorage.getItem('quote');

    if (storage) {
      commit('updateState', { prop: 'quote', value: JSON.parse(storage) });
    }

    return {};
  },
  async createQuote({ state, rootGetters, rootState, dispatch }) {
    const switchType = rootGetters['quote/quoteType'];
    const is02Meter = rootGetters['quote/is02Meter'];
    const { referrerBranchCode, switchOwnerReference } = rootState.app_settings;
    const data = formatModel(state, switchType, is02Meter, referrerBranchCode, switchOwnerReference);
    const url = {
      gasToGas: '/request/switch/v2/gas',
      electricityToElectricity: '/request/switch/v2/electricity',
      dualConsolidatedToDualConsolidated: '/request/switch/v2/dual-consolidated',
      dualDistinctToDualConsolidated: '/request/switch/v2/dual-distinct'
    };

    try {
      const res = await axios({
        method: 'POST',
        url: url[switchType],
        data
      });

      if (res.status === 200) {
        await dispatch('storage/save', {
          prop: 'quote',
          value: {
            completionDate: state.completionDate,
            exchanged: state.exchanged,
            switchId: res.data.geniusSwitchDto.switchId,
            switchType,
            includeAllPayMethodOptions: true,
            proposedPayMethod: data.newTariffPaymentMethod,
            electricitySmartMeterInstalled: state.electricitySmartMeterInstalled == true,
            gasSmartMeterInstalled: state.gasSmartMeterInstalled == true
          }
        }, { root: true });
      }
    } catch (error) {
      return error.data.message;
    }
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  },
  resetState(state) {
    Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
